var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLightsOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.049 -2.41)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(52.534 2.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(48.11 3.809) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.137,
    height: 2.273,
    transform: "translate(44.944 7.347) rotate(-60.113)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(44.049 10.792)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(44.877 15.383) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(48.017 18.967) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(52.431 18.144)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(55.883 17.616) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.133,
    height: 2.266,
    transform: "translate(58.65 15.306) rotate(-60)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(59.783 10.895)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(58.695 7.599) rotate(-30)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.266,
    height: 1.133,
    transform: "translate(55.969 5.257) rotate(-60)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.04,16.491A5.054,5.054,0,1,1,58.1,11.437,5.06,5.06,0,0,1,53.04,16.491Zm0-9.109A4.055,4.055,0,1,0,57.1,11.437,4.061,4.061,0,0,0,53.04,7.382Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLightsOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lights-off.83a15420082316795aae74375a9e61bb.svg";